import { FunctionalComponent, h } from 'preact';

import { preactDynamicComponent } from 'common/module/preact/dynamic/component';
import { TelephoneInputTemplate } from 'common/module/telephone-input/template';
import { TelephoneInputViewOptionsInterface } from 'common/module/telephone-input/view-options.interface';
import { TelephoneInputViewStoreFactory } from 'common/module/telephone-input/view-store.factory';

const TelephoneInput = preactDynamicComponent(TelephoneInputTemplate);

export const TelephoneInputComponent: FunctionalComponent<TelephoneInputViewOptionsInterface> = (props) => {
  const store = TelephoneInputViewStoreFactory();
  store.initialize({
    name: props.name,
    placeholder: props.placeholder,
    value: props.value,
    onChange: props.onChange,
    onBlur: props.onBlur,
    hasError: props.hasError,
    selectedCountry: props.selectedCountry,
    countriesList: props.countriesList,
    onClickChangeCountryCode: props.onClickChangeCountryCode,
    isLoading: props.isLoading,
  });

  return <TelephoneInput viewStore={store} mapState={() => ({ ...store.getState(), hasError: props.hasError })} />;
};
